import { useLinkComponent } from "@outschool/ui-utils";
import React from "react";

import CategoryNavbar from "../CategoryNavbar";
import HeaderLogo from "./HeaderLogo";
import HeaderNavItem from "./HeaderNavItem";

export default function StandardHeaderLeft({
  rootPath,
  showCategoriesNavbar,
  forceLargeLogo,
}: {
  rootPath: string;
  showCategoriesNavbar?: boolean;
  forceLargeLogo?: boolean;
}) {
  const Link = useLinkComponent();
  return (
    <>
      <HeaderNavItem
        sx={{
          paddingX: 0,
          display: "flex",
          marginRight: "auto",
        }}
      >
        <Link
          to={rootPath}
          trackingName="nav_logo"
          reloadDocument
          style={{ display: "flex" }}
          aria-label="homepage button"
        >
          <HeaderLogo isWhiteText={false} forceLargeLogo={forceLargeLogo} />
        </Link>
      </HeaderNavItem>
      {showCategoriesNavbar && <CategoryNavbar useButton />}
    </>
  );
}
